import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Coins, Calendar, MapPin, Mail, Settings, Building2, ShieldCheck } from "lucide-react";
import { get } from "@/lib/api";

export default function Profile() {
  const { data: me } = useQuery({ queryKey: ["me"], queryFn: () => get("/me") });
  const { data: bookings = [] } = useQuery({ queryKey: ["bookings"], queryFn: () => get("/bookings") });

  const stats = [
    { label: "Kredi bakiyesi", value: me?.credits ?? "—", icon: Coins },
    { label: "Toplam rezervasyon", value: bookings.length, icon: Calendar },
    { label: "Katıldığı seans", value: bookings.filter((b) => b.status === "attended").length, icon: ShieldCheck },
  ];

  return (
    <div className="mx-auto max-w-4xl px-5 py-10 lg:px-8">
      <div className="flex flex-col items-center gap-4 rounded-3xl border border-[#E5E0D8] bg-white p-8 text-center sm:flex-row sm:text-left">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#8C6A5D] font-display text-3xl font-semibold text-white">
          {me?.name?.charAt(0) ?? "?"}
        </div>
        <div className="flex-1">
          <h1 className="font-display text-3xl font-semibold">{me?.name ?? "—"}</h1>
          <div className="mt-2 flex flex-wrap justify-center gap-4 text-sm text-[#5C5856] sm:justify-start">
            <span className="flex items-center gap-1.5"><Mail className="h-4 w-4" /> {me?.email}</span>
            <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4" /> {me?.city}</span>
            <span className="flex items-center gap-1.5"><Calendar className="h-4 w-4" /> Üyelik: {me?.member_since}</span>
          </div>
        </div>
        <button data-testid="edit-profile-button" className="flex items-center gap-2 rounded-full border border-[#E5E0D8] px-5 py-2.5 text-sm transition-colors hover:bg-[#F4EFE7]">
          <Settings className="h-4 w-4" /> Düzenle
        </button>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-2xl border border-[#E5E0D8] bg-white p-5">
            <s.icon className="h-5 w-5 text-[#8C6A5D]" />
            <p className="mt-3 font-display text-3xl font-semibold">{s.value}</p>
            <p className="text-sm text-[#5C5856]">{s.label}</p>
          </div>
        ))}
      </div>

      <h2 className="mt-10 font-display text-2xl font-semibold">Diğer paneller</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        <Link to="/partner" data-testid="profile-partner-link" className="flex items-center gap-4 rounded-2xl border border-[#E5E0D8] bg-white p-5 transition-colors hover:border-[#8C6A5D]">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#E8DED1] text-[#8C6A5D]"><Building2 className="h-6 w-6" /></div>
          <div><p className="font-medium">Stüdyo Paneli</p><p className="text-sm text-[#5C5856]">İşletme yönetim arayüzü</p></div>
        </Link>
        <Link to="/panel-yonetim" data-testid="profile-admin-link" className="flex items-center gap-4 rounded-2xl border border-[#E5E0D8] bg-white p-5 transition-colors hover:border-[#8C6A5D]">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#E8DED1] text-[#8C6A5D]"><ShieldCheck className="h-6 w-6" /></div>
          <div><p className="font-medium">Admin Paneli</p><p className="text-sm text-[#5C5856]">Platform yönetimi</p></div>
        </Link>
      </div>
    </div>
  );
}
